const RTL_LANGS = ['ar', 'ar_YP'];
export const isLanguageRTL = (lng) => {
  return RTL_LANGS.indexOf(lng) !== -1;
};
